import { useContext } from "react"
import { useTranslation } from "react-i18next"
import Button from "mobile/components/Button"
import Text from "mobile/components/Text"

import Modal from "../index"
import StatusModal from "../StatusModal"

import { ModalContext } from "./Context"

const ModalOverlay = () => {
  const { t } = useTranslation("label")
  const { modal, handleModal, modalContent = {} } = useContext(ModalContext)
  const { status, action, statusText, text, title, buttonText } = modalContent

  if (!status) {
    return (
      <Modal
        isOpen={modal}
        hasMinHeight={false}
        showCloseIcon={true}
        title={t(title)}
        onToggle={() => handleModal()}
        footer={
          <Button
            onClick={() => {
              handleModal()
              action && action()
            }}>
            {buttonText ?? t("okay")}
          </Button>
        }>
        <Text>{text}</Text>
      </Modal>
    )
  }

  return (
    <StatusModal
      isOpen={modal}
      title={title}
      statusText={statusText}
      status={status}
      onToggle={() => handleModal()}
      footer={<Button onClick={() => handleModal()}>{t("okay")}</Button>}>
      <Text>{text}</Text>
    </StatusModal>
  )
}

export default ModalOverlay
